// src/pages/gerenciar/ImportarExportarDados.jsx
import React, { useState } from "react";

import { useTheme } from "../../contexts/ThemeContext";
import { useAuth } from "../../contexts/AuthContext";
import LayoutDesktop from "../../layouts/LayoutDesktop";

import { db } from "../../config/firebase";
import {
  collection,
  getDocs,
  query,
  where,
  updateDoc,
  addDoc,
  doc,
  runTransaction,
} from "firebase/firestore";

const IconEmpresa = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="4" y="2" width="16" height="20" rx="2" />
    <path d="M9 22v-4h6v4" />
    <path d="M8 6h.01M16 6h.01M8 10h.01M16 10h.01M8 14h.01M16 14h.01M12 6h.01M12 10h.01M12 14h.01" />
  </svg>
);

const IconSetor = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M3 21h18" />
    <path d="M5 21V7l8-4v18" />
    <path d="M19 21V11l-6-3" />
    <path d="M9 9v.01M9 12v.01M9 15v.01M9 18v.01" />
  </svg>
);

const IconMaquina = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);


const IconUsuario = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const IconDefeito = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const IconFornecedor = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="1" y="3" width="15" height="13" rx="2" />
    <path d="M16 8h4l3 4v5h-7V8z" />
    <circle cx="5.5" cy="18.5" r="2.5" />
    <circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);

const IconPeca = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

// novos ícones
const IconOS = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="4" y="3" width="16" height="18" rx="2" />
    <path d="M8 7h8M8 11h8M8 15h5" />
  </svg>
);

const IconAtendimento = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M4 4h10v6H4z" />
    <path d="M4 14h6v6H4z" />
    <path d="M16 12l4 4-4 4" />
  </svg>
);

const TIPOS_DADOS = [
  {
    value: "empresas",
    label: "Empresas",
    icon: <IconEmpresa />,
    descricao: "Nome, CNPJ e endereço das empresas.",
    colunas: ["codigo", "nome", "cnpj", "endereco"],
  },
  {
    value: "setores",
    label: "Setores",
    icon: <IconSetor />,
    descricao: "Setores vinculados às empresas.",
    colunas: ["codigo", "nome", "empresaCodigo", "responsavel", "telefone"],
  },
  {
    value: "maquinas",
    label: "Máquinas",
    icon: <IconMaquina />,
    descricao: "Máquinas com modelo, fabricante, datas e máquina chave.",
    colunas: [
      "codigo",
      "nome",
      "modelo",
      "fabricante",
      "numeroSerie",
      "dataInstalacao",
      "dataFabricacao",
      "maquinaChave",
      "empresaCodigo",
      "setorCodigo",
    ],
  },
{
    value: "usuarios",
    label: "Usuários",
    icon: <IconUsuario />,
    descricao: "Nome, email, perfil e empresa dos usuários.",
    colunas: ["codigo", "nome", "email", "perfil", "empresa", "ativo"],
  },
  {
    value: "defeitos",
    label: "Defeitos",
    icon: <IconDefeito />,
    descricao: "Defeitos cadastrados por máquina.",
    colunas: ["codigo", "nome", "empresaNome", "setorNome", "observacoes"],
  },
  {
    value: "fornecedores",
    label: "Fornecedores",
    icon: <IconFornecedor />,
    descricao: "Fornecedores de peças e serviços.",
    colunas: ["codigo", "nome", "cnpj", "telefone", "email", "endereco"],
  },
  {
    value: "pecas",
    label: "Peças",
    icon: <IconPeca />,
    descricao: "Peças de reposição e estoque.",
    colunas: ["codigo", "nome", "descricao", "unidade", "estoqueMinimo", "localizacao"],
  },
  {
    value: "ordensServico",
    label: "Ordens de Serviço",
    icon: <IconOS />,
    descricao: "Cabeçalho das OS (usando empresaCodigo, setorCodigo, maquinaCodigo).",
    colunas: [
      "codigo",            // OS0001
      "empresaCodigo",     // EM0001
      "setorCodigo",       // ST001
      "maquinaCodigo",     // MQ0001
        // SM001 (opcional)
      "defeitoApresentado",
      "criticidade",
      "maquinaParou",
      "tipoServico",
      "status",
      "dataAbertura",
      "abertaPor",
    ],
  },
  {
    value: "atendimentos",
    label: "Atendimentos",
    icon: <IconAtendimento />,
    descricao: "Atendimentos de OS (sub-OS).",
    colunas: [
      "codigo",               // opcional
      "osCodigo",             // OS0001
      "subnumero",            // 1, 2, 3...
      "defeitoApresentado",
      "defeitoEncontrado",
      "servicoExecutado",
      "horarioInicio",
      "horarioFim",
      "tecnicoNome",
      "status",
      "maquinaContinuaParada",
    ],
  },
];

const SEPARADOR = ";";

// Configuração de geração de códigos sequenciais por tipo de dado
// Mantém o mesmo padrão utilizado nas telas de cadastro (EM, ST, MQ, SM, US, FN, PE...)
const CODIGO_CONFIG = {
  empresas: { contadorPrefixo: "empresas_", prefixo: "EM", largura: 4, inicial: 1 },
  setores: { contadorPrefixo: "setores_", prefixo: "ST", largura: 3, inicial: 0 },
  maquinas: { contadorPrefixo: "maquinas_", prefixo: "MQ", largura: 4, inicial: 0 },
usuarios: { contadorPrefixo: "usuarios_", prefixo: "US", largura: 4, inicial: 1 },
  fornecedores: { contadorPrefixo: "fornecedores_", prefixo: "FN", largura: 4, inicial: 0 },
  pecas: { contadorPrefixo: "pecas_", prefixo: "PE", largura: 4, inicial: 0 },
  // não inclui OS/Atendimentos aqui – código delas você já controla em outro fluxo
};

// Gera { sequencial, codigoGerado } para o tipo informado, atualizando o contador no Firestore
async function gerarCodigoSequencialPorTipo(tipo, grupoId) {
  const config = CODIGO_CONFIG[tipo];
  if (!config || !grupoId) return { sequencial: null, codigoGerado: null };

  const { contadorPrefixo, prefixo, largura, inicial } = config;
  const contadorRef = doc(db, "contadores", `${contadorPrefixo}${grupoId}`);

  const sequencial = await runTransaction(db, async (transaction) => {
    const snap = await transaction.get(contadorRef);

    let atual = inicial;
    if (snap.exists() && snap.data().ultimoCodigoSequencial != null) {
      atual = snap.data().ultimoCodigoSequencial;
    }

    const novoValor = atual + 1;

    transaction.set(
      contadorRef,
      { ultimoCodigoSequencial: novoValor, grupoId },
      { merge: true }
    );

    return novoValor;
  });

  const codigoGerado = `${prefixo}${String(sequencial).padStart(largura, "0")}`;
  return { sequencial, codigoGerado };
}

function normalizaCampo(valor) {
  return String(valor ?? "")
    .replace(/\r?\n/g, " ")
    .trim();
}

function criaCsv(dados, colunas) {
  const linhas = [colunas.join(SEPARADOR)];
  for (const item of dados) {
    const linha = colunas.map((col) => {
      let valor = item[col];
      if (typeof valor === "boolean") valor = valor ? "true" : "false";
      return normalizaCampo(valor);
    });
    linhas.push(linha.join(SEPARADOR));
  }
  return linhas.join("\r\n");
}

function parseCsv(texto) {
  const linhasBrutas = texto
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l.length > 0);

  if (linhasBrutas.length === 0) return { header: [], rows: [] };

  // Detecta automaticamente o separador da primeira linha
  const primeira = linhasBrutas[0];
  let separador = SEPARADOR; // padrão ";"

  if (primeira.includes(",") && !primeira.includes(";")) {
    separador = ","; // CSV com vírgula
  }

  const header = primeira.split(separador).map((h) => h.trim());
  const rows = [];

  for (let i = 1; i < linhasBrutas.length; i += 1) {
    const partes = linhasBrutas[i].split(separador);
    const obj = {};
    header.forEach((col, idx) => {
      obj[col] = (partes[idx] ?? "").trim();
    });
    rows.push(obj);
  }

  return { header, rows };
}

function interpretaBoolean(valor) {
  if (typeof valor === "boolean") return valor;
  const raw = String(valor ?? "").trim().toLowerCase();
  if (["true", "1", "sim", "s"].includes(raw)) return true;
  if (["false", "0", "nao", "não", "n"].includes(raw)) return false;
  return null;
}

function normalizaColuna(nome) {
  return String(nome ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "");
}

const SCRIPT_GPT = `# Instruções para Geração de Dados CSV - Sistema Mamute

Você é um assistente especializado em gerar arquivos CSV para importação no Sistema Mamute de Manutenção.

## REGRAS IMPORTANTES:
1. Use ponto-e-vírgula (;) como separador de colunas
2. A primeira linha DEVE ser o cabeçalho com os nomes exatos das colunas
3. Mantenha os códigos consistentes entre os arquivos (ex: EM0001 na empresa = EM0001 no setor)
4. Campos booleanos aceitem: true/false, sim/nao, 1/0
5. Datas no formato: DD/MM/AAAA ou AAAA-MM-DD
6. Não deixe linhas em branco

## ESTRUTURA DOS DADOS (ordem de importação):

### 1. EMPRESAS (importar primeiro)
Colunas: codigo;nome;cnpj;endereco
Exemplo:
codigo;nome;cnpj;endereco
EM0001;Phoenix Injeção;12.345.678/0001-90;Rua das Indústrias, 100
EM0002;Mamute Plásticos;98.765.432/0001-10;Av. Principal, 500

### 2. SETORES (requer empresas)
Colunas: codigo;nome;empresaCodigo;responsavel;telefone
- empresaCodigo: deve existir na planilha de Empresas
Exemplo:
codigo;nome;empresaCodigo;responsavel;telefone
ST001;Injeção;EM0001;João Silva;11999998888
ST002;Extrusão;EM0001;Maria Santos;11988887777

### 3. MÁQUINAS (requer empresas e setores)
Colunas: codigo;nome;modelo;fabricante;numeroSerie;dataInstalacao;dataFabricacao;maquinaChave;empresaCodigo;setorCodigo
- maquinaChave: sim ou nao (máquina crítica para produção)
Exemplo:
codigo;nome;modelo;fabricante;numeroSerie;dataInstalacao;dataFabricacao;maquinaChave;empresaCodigo;setorCodigo
MQ0001;Injetora 01;HT-500;Haitian;SN123456;01/01/2020;15/06/2019;sim;EM0001;ST001
MQ0002;Injetora 02;HT-300;Haitian;SN789012;15/03/2021;10/01/2021;nao;EM0001;ST001


### 5. USUÁRIOS
Colunas: codigo;nome;email;perfil;empresa;ativo
- perfil: Gestor, Administrador, Técnico Sênior, Técnico, Cliente, Kiosk
- ativo: sim ou nao
Exemplo:
codigo;nome;email;perfil;empresa;ativo
US0001;André Souza;andre@email.com;Gestor;Phoenix Injeção;sim
US0002;Carlos Manutenção;carlos@email.com;Técnico;Phoenix Injeção;sim

### 6. DEFEITOS
Colunas: codigo;nome;empresaNome;setorNome;observacoes
Exemplo:
codigo;nome;empresaNome;setorNome;observacoes
DF001;Vazamento de óleo;Phoenix Injeção;Injeção;Verificar mangueiras e conexões
DF002;Aquecimento excessivo;Phoenix Injeção;Injeção;Checar sistema de refrigeração

### 7. FORNECEDORES
Colunas: codigo;nome;cnpj;telefone;email;endereco
Exemplo:
codigo;nome;cnpj;telefone;email;endereco
FN0001;Rolamentos Brasil;11.222.333/0001-44;1133334444;contato@rolamentos.com;Rua Industrial, 50
FN0002;Hidráulica Total;55.666.777/0001-88;1155556666;vendas@hidraulica.com;Av. Técnica, 200

### 8. PEÇAS
Colunas: codigo;nome;descricao;unidade;estoqueMinimo;localizacao
Exemplo:
codigo;nome;descricao;unidade;estoqueMinimo;localizacao
PE0001;Rolamento 6205;Rolamento rígido de esferas;UN;10;Prateleira A1
PE0002;Óleo hidráulico;Óleo ISO VG 46;LT;50;Área de lubrificantes

### 9. ORDENS DE SERVIÇO (requer empresas, setores, máquinas)
Colunas: codigo;empresaCodigo;setorCodigo;maquinaCodigo;defeitoApresentado;criticidade;maquinaParou;tipoServico;status;dataAbertura;abertaPor
- codigo: Código único da OS (ex: OS0001)
- empresaCodigo, setorCodigo, maquinaCodigo: códigos existentes
- criticidade: Baixa, Média, Alta, Crítica
- maquinaParou: sim ou nao
- tipoServico: Corretiva, Preventiva, Melhoria
- status: Aberta, Em Atendimento, Aguardando Peça, Finalizada, Cancelada
- dataAbertura: DD/MM/AAAA
Exemplo:
codigo;empresaCodigo;setorCodigo;maquinaCodigo;defeitoApresentado;criticidade;maquinaParou;tipoServico;status;dataAbertura;abertaPor
OS0001;EM0001;ST001;MQ0001;;Vazamento de óleo no cilindro;Alta;sim;Corretiva;Aberta;01/12/2024;João Silva
OS0002;EM0001;ST001;MQ0002;SM001;Aquecimento excessivo;Média;nao;Corretiva;Em Atendimento;02/12/2024;Maria Santos

### 10. ATENDIMENTOS (requer Ordens de Serviço)
Colunas: codigo;osCodigo;subnumero;tecnicoNome;defeitoApresentado;defeitoEncontrado;servicoExecutado;maquinaContinuaParada;statusAtendimento;dataInicio;dataFim
- osCodigo: código da OS (ex: OS0001)
- subnumero: número sequencial do atendimento (1, 2, 3...)
- tecnicoNome: nome do técnico responsável
- defeitoApresentado: descrição do defeito informado
- defeitoEncontrado: descrição do defeito real encontrado
- servicoExecutado: descrição do serviço realizado
- maquinaContinuaParada: sim ou nao
- statusAtendimento: Pré-Atendimento, Em Andamento, Finalizado, Cancelado
- dataInicio e dataFim: DD/MM/AAAA HH:MM ou DD/MM/AAAA
Exemplo:
codigo;osCodigo;subnumero;tecnicoNome;defeitoApresentado;defeitoEncontrado;servicoExecutado;maquinaContinuaParada;statusAtendimento;dataInicio;dataFim
AT0001;OS0001;1;Carlos Manutenção;Vazamento de óleo;Retentor danificado;Troca do retentor e limpeza;nao;Finalizado;01/12/2024 08:00;01/12/2024 10:30
AT0002;OS0002;1;André Souza;Aquecimento excessivo;Sensor com defeito;Troca do sensor de temperatura;nao;Em Andamento;02/12/2024 14:00;

## RELACIONAMENTOS ENTRE OS E ATENDIMENTOS:
- Uma OS pode ter VÁRIOS atendimentos (1:N)
- Cada atendimento tem um subnumero que indica a ordem (1, 2, 3...)
- O primeiro atendimento geralmente é subnumero=1
- Atendimentos subsequentes indicam retrabalho ou continuação do serviço
- O status da OS depende dos atendimentos (se todos finalizados, OS pode ser fechada)

## QUANDO O USUÁRIO ENVIAR PLANILHAS:
1. Analise os dados fornecidos
2. Identifique qual tipo de dado é (empresa, setor, máquina, etc)
3. Gere CSVs separados para cada tipo
4. Mantenha relacionamentos consistentes (códigos)
5. Gere os arquivos na ordem correta de importação

## FORMATO DE RESPOSTA:
Para cada tipo de dado, forneça:
~~~csv
[nome_do_arquivo.csv]
codigo;coluna1;coluna2;...
dado1;dado2;dado3;...
~~~

Aguardo os dados do usuário para processar.`;

function ImportarExportarDados() {
  const { tema } = useTheme();
  const { usuario: usuarioLogado } = useAuth();

  const [abaAtiva, setAbaAtiva] = useState("dados"); // 'dados' | 'assistente'
  const [tipoSelecionado, setTipoSelecionado] = useState(null);
  const [modoAtivo, setModoAtivo] = useState(null); // 'exportar' | 'importar'
  const [copiado, setCopiado] = useState(false);

  const [arquivoNome, setArquivoNome] = useState("");
  const [previewHeader, setPreviewHeader] = useState([]);
  const [previewRows, setPreviewRows] = useState([]);
  const [parsedRows, setParsedRows] = useState([]);

  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [resumoImportacao, setResumoImportacao] = useState(null);

  // Estado para dados cadastrados (para o script GPT)
  const [dadosCadastrados, setDadosCadastrados] = useState(null);
  const [carregandoDados, setCarregandoDados] = useState(false);

  const tipoConfig = TIPOS_DADOS.find((t) => t.value === tipoSelecionado);

  // Função para carregar todos os dados cadastrados
  const carregarDadosCadastrados = async () => {
    if (!usuarioLogado?.grupoId) return;
    
    setCarregandoDados(true);
    try {
      const grupoId = usuarioLogado.grupoId;
      
      // Buscar empresas
      const empresasSnap = await getDocs(query(collection(db, "empresas"), where("grupoId", "==", grupoId)));
      const empresas = empresasSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      // Buscar setores
      const setoresSnap = await getDocs(query(collection(db, "setores"), where("grupoId", "==", grupoId)));
      const setores = setoresSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      // Buscar máquinas
      const maquinasSnap = await getDocs(query(collection(db, "maquinas"), where("grupoId", "==", grupoId)));
      const maquinas = maquinasSnap.docs.map(d => ({ id: d.id, ...d.data() }));

      // Buscar OS
      const osSnap = await getDocs(query(collection(db, "ordensServico"), where("grupoId", "==", grupoId)));
      const ordensServico = osSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      // Buscar usuários
      const usuariosSnap = await getDocs(query(collection(db, "usuarios"), where("grupoId", "==", grupoId)));
      const usuarios = usuariosSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      // Buscar fornecedores
      const fornecedoresSnap = await getDocs(query(collection(db, "fornecedores"), where("grupoId", "==", grupoId)));
      const fornecedores = fornecedoresSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      // Buscar peças
      const pecasSnap = await getDocs(query(collection(db, "pecas"), where("grupoId", "==", grupoId)));
      const pecas = pecasSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      // Buscar defeitos
      const defeitosSnap = await getDocs(query(collection(db, "defeitos"), where("grupoId", "==", grupoId)));
      const defeitos = defeitosSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      setDadosCadastrados({
        empresas,
        setores,
        maquinas,
ordensServico,
        usuarios,
        fornecedores,
        pecas,
        defeitos,
      });
    } catch (err) {
      console.error("Erro ao carregar dados:", err);
    } finally {
      setCarregandoDados(false);
    }
  };

  // Gerar script dinâmico com dados cadastrados
  const gerarScriptComDados = () => {
    let dadosSection = "";
    
    if (dadosCadastrados) {
      dadosSection = `

## DADOS JÁ CADASTRADOS NO SISTEMA (use estes códigos para relacionamentos):

### EMPRESAS CADASTRADAS:
| Código | Nome |
|--------|------|
${dadosCadastrados.empresas.length > 0 
  ? dadosCadastrados.empresas.map(e => `| ${e.codigo || '-'} | ${e.nome || '-'} |`).join('\n')
  : '| (nenhuma empresa cadastrada) | |'}

### SETORES CADASTRADOS:
| Código | Nome | Empresa |
|--------|------|---------|
${dadosCadastrados.setores.length > 0 
  ? dadosCadastrados.setores.map(s => `| ${s.codigo || '-'} | ${s.nome || '-'} | ${s.empresaNome || s.empresaCodigo || '-'} |`).join('\n')
  : '| (nenhum setor cadastrado) | | |'}

### MÁQUINAS CADASTRADAS:
| Código | Nome | Setor | Empresa |
|--------|------|-------|---------|
${dadosCadastrados.maquinas.length > 0 
  ? dadosCadastrados.maquinas.map(m => `| ${m.codigo || '-'} | ${m.nome || '-'} | ${m.setorNome || '-'} | ${m.empresaNome || '-'} |`).join('\n')
  : '| (nenhuma máquina cadastrada) | | | |'}


### ORDENS DE SERVIÇO CADASTRADAS:
| Código | Título | Status | Máquina |
|--------|--------|--------|---------|
${dadosCadastrados.ordensServico.length > 0 
  ? dadosCadastrados.ordensServico.slice(0, 50).map(os => `| ${os.codigo || '-'} | ${(os.titulo || '-').substring(0, 30)} | ${os.statusNome || '-'} | ${os.maquinaNome || '-'} |`).join('\n')
  : '| (nenhuma OS cadastrada) | | | |'}
${dadosCadastrados.ordensServico.length > 50 ? `\n... e mais ${dadosCadastrados.ordensServico.length - 50} OS` : ''}

### USUÁRIOS/TÉCNICOS CADASTRADOS:
| Nome | Perfil |
|------|--------|
${dadosCadastrados.usuarios.length > 0 
  ? dadosCadastrados.usuarios.map(u => `| ${u.nome || u.displayName || '-'} | ${u.perfil || '-'} |`).join('\n')
  : '| (nenhum usuário cadastrado) | |'}

---
**IMPORTANTE:** Ao gerar CSVs que referenciam outros dados (ex: Setores precisam de empresaCodigo), 
use EXATAMENTE os códigos listados acima. Se o código não existir na lista, o import vai falhar.
`;
    }
    
    return SCRIPT_GPT + dadosSection;
  };

  const handleCopiarScript = async () => {
    try {
      const scriptCompleto = gerarScriptComDados();
      await navigator.clipboard.writeText(scriptCompleto);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch (err) {
      console.error("Erro ao copiar:", err);
    }
  };

  const obterAjudaImportacao = () => {
    if (!tipoSelecionado) return "";
    switch (tipoSelecionado) {
      case "setores":
        return 'Para vincular os setores à empresa correta, use SEMPRE a coluna "empresaCodigo" exatamente como está no cadastro (por exemplo, EM0001). O relacionamento é feito pelo código, não pelo nome, e para NOVOS setores deixe a coluna "codigo" em branco.';
      case "maquinas":
        return 'Use as colunas "empresaCodigo" e "setorCodigo" para vincular as máquinas. Os nomes são apenas informativos: quem manda no vínculo são os códigos. Para NOVAS máquinas deixe a coluna "codigo" em branco; use o código apenas para atualizar registros existentes.';

      case "ordensServico":
      case "atendimentos":
        return 'Para Atendimentos, use osCodigo (código da OS) e subnumero para identificar cada atendimento. É ótimo para ajustar textos de defeito encontrado, serviço executado e status em lote.';
      default:
        return 'Use a planilha modelo para ver as colunas esperadas. Sempre que houver empresa/setor/máquina, o vínculo é feito por código (empresaCodigo, setorCodigo, maquinaCodigo).';
    }
  };


  const gerarScriptChatGPT = () => {
    if (!tipoSelecionado || !tipoConfig) {
      return "";
    }

    const colunasCsv = (tipoConfig.colunas || []).join(", ");

    // Aproveita a mesma configuração de códigos usada no backend de importação
    const configCodigo = CODIGO_CONFIG[tipoSelecionado];

    let instrucoesCodigo = "";
    if (configCodigo && tipoConfig.colunas.includes("codigo")) {
      const exemplo1 = `${configCodigo.prefixo}${String(1).padStart(configCodigo.largura, "0")}`;
      const exemplo2 = `${configCodigo.prefixo}${String(2).padStart(configCodigo.largura, "0")}`;

      instrucoesCodigo = `
  - Converta a coluna "codigo" para o padrão do sistema **Mamute**:
    - Use o prefixo **${configCodigo.prefixo}** seguido de um número com **${configCodigo.largura} dígitos**.
    - Exemplos: **${exemplo1}, ${exemplo2}, ...**
    - Gere os códigos em sequência, respeitando a **ordem original das linhas da planilha**.
    - Se já existirem códigos em outro formato, ignore o formato antigo e gere novos códigos nesse padrão, sem pular números.
  `;
    } else if (tipoConfig.colunas.includes("codigo")) {
      instrucoesCodigo = `
  - Se existir coluna "codigo", padronize os valores para um formato consistente (por exemplo, OS0001, OS0002, ...), mantendo a ordem original da planilha.
  `;
    }

    let instrucoesRelacionamentos = "";
    const colunas = tipoConfig.colunas || [];
    if (
      ["empresaCodigo", "setorCodigo", "maquinaCodigo"].some((c) =>
        colunas.includes(c)
      )
    ) {
      instrucoesRelacionamentos = `
  - Para colunas de relacionamento como "empresaCodigo", "setorCodigo", "maquinaCodigo" :
    - Utilize os códigos já padronizados do Mamute (por exemplo: **EM0001** para empresa, **ST001** para setor, **MQ0001** para máquina).
    - Se na planilha original existirem apenas nomes (sem código), mantenha os nomes nas colunas de nome (como "empresaNome", "setorNome") e deixe as colunas "...Codigo" vazias em vez de inventar códigos.
  `;
    }

    // Gerar seção de dados cadastrados específica para o tipo selecionado
    let dadosSection = "";
    if (dadosCadastrados) {
      dadosSection = `

---
## DADOS JÁ CADASTRADOS NO SISTEMA (use estes códigos para relacionamentos):
`;
      
      // Empresas - relevante para: setores, máquinas, OS
      if (["setores", "maquinas", "ordensServico"].includes(tipoSelecionado)) {
        dadosSection += `
### EMPRESAS CADASTRADAS:
| Código | Nome |
|--------|------|
${dadosCadastrados.empresas.length > 0 
  ? dadosCadastrados.empresas.map(e => `| ${e.codigo || '-'} | ${e.nome || '-'} |`).join('\n')
  : '| (nenhuma empresa cadastrada) | |'}
`;
      }

      // Setores - relevante para: máquinas, OS
      if (["maquinas", "ordensServico"].includes(tipoSelecionado)) {
        dadosSection += `
### SETORES CADASTRADOS:
| Código | Nome | empresaCodigo |
|--------|------|---------------|
${dadosCadastrados.setores.length > 0 
  ? dadosCadastrados.setores.map(s => {
      const emp = dadosCadastrados.empresas.find(e => e.id === s.empresaId);
      return `| ${s.codigo || '-'} | ${s.nome || '-'} | ${emp?.codigo || s.empresaCodigo || '-'} |`;
    }).join('\n')
  : '| (nenhum setor cadastrado) | | |'}
`;
      }

      // Máquinas - relevante para: máquinas, OS
      if (["ordensServico"].includes(tipoSelecionado)) {
        dadosSection += `
### MÁQUINAS CADASTRADAS:
| Código | Nome | setorCodigo | empresaCodigo | maquinaChave |
|--------|------|-------------|---------------|--------------|
${dadosCadastrados.maquinas.length > 0 
  ? dadosCadastrados.maquinas.map(m => {
      const emp = dadosCadastrados.empresas.find(e => e.id === m.empresaId);
      const set = dadosCadastrados.setores.find(s => s.id === m.setorId);
      return `| ${m.codigo || '-'} | ${m.nome || '-'} | ${set?.codigo || m.setorCodigo || '-'} | ${emp?.codigo || m.empresaCodigo || '-'} | ${m.maquinaChave ? 'Sim' : 'Não'} |`;
    }).join('\n')
  : '| (nenhuma máquina cadastrada) | | | | |'}
`;
      }

      // Submáquinas - relevante para: OS
      if (["ordensServico"].includes(tipoSelecionado)) {
        dadosSection += `

`;
      }

      // Ordens de Serviço - relevante para: atendimentos
      if (["atendimentos"].includes(tipoSelecionado)) {
        dadosSection += `
### ORDENS DE SERVIÇO CADASTRADAS:
| Código | Título | Status | Máquina |
|--------|--------|--------|---------|
${dadosCadastrados.ordensServico.length > 0 
  ? dadosCadastrados.ordensServico.slice(0, 100).map(os => `| ${os.codigo || '-'} | ${(os.titulo || os.defeitoApresentado || '-').substring(0, 40)} | ${os.statusNome || '-'} | ${os.maquinaNome || '-'} |`).join('\n')
  : '| (nenhuma OS cadastrada) | | | |'}
${dadosCadastrados.ordensServico.length > 100 ? `\n... e mais ${dadosCadastrados.ordensServico.length - 100} OS` : ''}
`;
      }

      // Usuários/Técnicos - relevante para: OS, atendimentos
      if (["ordensServico", "atendimentos", "usuarios"].includes(tipoSelecionado)) {
        dadosSection += `
### USUÁRIOS/TÉCNICOS CADASTRADOS:
| Nome | Perfil | Email |
|------|--------|-------|
${dadosCadastrados.usuarios.length > 0 
  ? dadosCadastrados.usuarios.map(u => `| ${u.nome || u.displayName || '-'} | ${u.perfil || '-'} | ${u.email || '-'} |`).join('\n')
  : '| (nenhum usuário cadastrado) | | |'}
`;
      }

      // Fornecedores - relevante para: peças, fornecedores
      if (["pecas", "fornecedores"].includes(tipoSelecionado)) {
        dadosSection += `
### FORNECEDORES CADASTRADOS:
| Código | Nome | CNPJ | Telefone |
|--------|------|------|----------|
${dadosCadastrados.fornecedores?.length > 0 
  ? dadosCadastrados.fornecedores.map(f => `| ${f.codigo || '-'} | ${f.nome || '-'} | ${f.cnpj || '-'} | ${f.telefone || '-'} |`).join('\n')
  : '| (nenhum fornecedor cadastrado) | | | |'}
`;
      }

      // Peças - relevante para: peças
      if (["pecas"].includes(tipoSelecionado)) {
        dadosSection += `
### PEÇAS CADASTRADAS:
| Código | Nome | Quantidade | Unidade |
|--------|------|------------|---------|
${dadosCadastrados.pecas?.length > 0 
  ? dadosCadastrados.pecas.slice(0, 50).map(p => `| ${p.codigo || '-'} | ${p.nome || '-'} | ${p.quantidade ?? '-'} | ${p.unidade || '-'} |`).join('\n')
  : '| (nenhuma peça cadastrada) | | | |'}
${dadosCadastrados.pecas?.length > 50 ? `\n... e mais ${dadosCadastrados.pecas.length - 50} peças` : ''}
`;
      }

      // Defeitos - relevante para: defeitos
      if (["defeitos"].includes(tipoSelecionado)) {
        dadosSection += `
### DEFEITOS CADASTRADOS:
| Código | Descrição | Máquina |
|--------|-----------|---------|
${dadosCadastrados.defeitos?.length > 0 
  ? dadosCadastrados.defeitos.slice(0, 50).map(d => `| ${d.codigo || '-'} | ${(d.descricao || d.nome || '-').substring(0, 40)} | ${d.maquinaNome || '-'} |`).join('\n')
  : '| (nenhum defeito cadastrado) | | |'}
${dadosCadastrados.defeitos?.length > 50 ? `\n... e mais ${dadosCadastrados.defeitos.length - 50} defeitos` : ''}
`;
      }

      dadosSection += `
---
**IMPORTANTE:** Ao gerar CSVs que referenciam outros dados, use EXATAMENTE os códigos listados acima. 
Se o código não existir na lista, o import vai falhar silenciosamente.
`;
    } else {
      dadosSection = `

---
**DICA:** Clique em "Carregar Dados do Sistema" para incluir os códigos já cadastrados neste script.
Assim o GPT poderá gerar os CSVs com os relacionamentos corretos.
`;
    }

    // Identificar campos booleanos do tipo
    const camposBooleanos = [];
    const camposStatus = [];
    const camposData = [];
    const camposCriticidade = [];
    
    if (colunas.includes("maquinaChave")) camposBooleanos.push("maquinaChave");
if (colunas.includes("maquinaParou")) camposBooleanos.push("maquinaParou");
    if (colunas.includes("maquinaContinuaParada")) camposBooleanos.push("maquinaContinuaParada");
    if (colunas.includes("ativo")) camposBooleanos.push("ativo");
    
    if (colunas.includes("status")) camposStatus.push("status");
    if (colunas.includes("statusAtendimento")) camposStatus.push("statusAtendimento");
    
    if (colunas.includes("criticidade")) camposCriticidade.push("criticidade");
    
    if (colunas.includes("dataAbertura")) camposData.push("dataAbertura");
    if (colunas.includes("dataInstalacao")) camposData.push("dataInstalacao");
    if (colunas.includes("dataFabricacao")) camposData.push("dataFabricacao");
    if (colunas.includes("dataInicio")) camposData.push("dataInicio");
    if (colunas.includes("dataFim")) camposData.push("dataFim");

    let instrucoesEspeciais = "";
    
    if (camposBooleanos.length > 0) {
      instrucoesEspeciais += `
### Campos Booleanos (Sim/Não)
Os seguintes campos aceitam valores booleanos: **${camposBooleanos.join(", ")}**
- Use **"sim"** ou **"nao"** (em português, sem acento)
- Também aceita: true/false, s/n, 1/0, yes/no
- **Recomendado:** Use "sim" ou "nao" para manter padrão em português
`;
    }
    
    if (camposStatus.length > 0) {
      instrucoesEspeciais += `
### Campos de Status
O campo **status** aceita os seguintes valores:
- **Aberta** (padrão para novas OS)
- **Aberta 24H** (OS crítica)
- **Em Atendimento**
- **Aguardando Peça** / **Aguardando Material**
- **Finalizada**
- **Cancelada**
`;
    }
    
    if (camposCriticidade.length > 0) {
      instrucoesEspeciais += `
### Campo Criticidade
O campo **criticidade** aceita os seguintes valores:
- **Urgente** ou **Alta** (prioridade máxima)
- **Media** ou **Média** (prioridade normal)
- **Baixa** (pode aguardar)
`;
    }
    
    if (camposData.length > 0) {
      instrucoesEspeciais += `
### Campos de Data
Os seguintes campos são datas: **${camposData.join(", ")}**
- Formato recomendado: **YYYY-MM-DD** (ex: 2024-12-06)
- Também aceita: DD/MM/YYYY, DD-MM-YYYY
`;
    }

    return `Quero que você crie um **arquivo CSV** pronto para importação no meu sistema de manutenção chamado **"Mamute"**.

Vou te enviar uma planilha (Excel ou CSV) com dados de **${tipoConfig.label}** usados em uma fábrica.

### 1) Estrutura do CSV de saída

- O arquivo final deve ser um CSV com **ponto-e-vírgula (;)** como separador de colunas.
- A **primeira linha** é o cabeçalho com estas colunas, **exatamente nesta ordem**:
  ${colunasCsv}
- Cada linha seguinte é um registro.
- Se algum campo não existir na planilha original, deixe a célula vazia.
- Não invente dados novos; apenas reorganize, limpe e padronize o que estiver na planilha.
${instrucoesCodigo}${instrucoesRelacionamentos}${instrucoesEspeciais}
### 2) Regras para os códigos

- A coluna "codigo" deve seguir o padrão definido acima, próprio do sistema Mamute.
- Os códigos devem ser gerados ou ajustados **na ordem das linhas da planilha**, para manter a consistência.

### 3) Formato da resposta

- Sua resposta deve ser **somente** o conteúdo do arquivo CSV final.
- Use um bloco de código markdown assim (pode usar ~~~ para evitar conflitos):

~~~csv
(cabeçalho e linhas em formato CSV, usando ; como separador)
~~~

- Não escreva explicações antes ou depois, apenas o CSV.

### 4) Passos que você deve seguir

1. Analise a planilha que eu enviar.
2. Mapeie as colunas atuais da planilha para as colunas do Mamute, na ordem indicada.
3. Se alguma coluna for ambígua, pode comentar rapidamente o que está diferente e sugerir como devo renomear/ajustar os cabeçalhos na planilha.
4. Em seguida, gere o CSV final já no padrão do Mamute (incluindo a padronização dos códigos), dentro do bloco csv.

Quando eu colar a planilha, siga esse roteiro automaticamente.
${dadosSection}`;
  };


  const handleBaixarModelo = async () => {
    if (!tipoSelecionado || !tipoConfig) return;

    const headerCols = tipoConfig.colunas || [];
    const header = headerCols.join(SEPARADOR);

    const colecaoMap = {
      empresas: "empresas",
      setores: "setores",
      maquinas: "maquinas",
usuarios: "usuarios",
      defeitos: "defeitos",
      fornecedores: "fornecedores",
      pecas: "pecas",
      ordensServico: "ordensServico",
      atendimentos: "atendimentos",
    };

    const colecao = colecaoMap[tipoSelecionado];

    let linhas = [header];

    try {
      // Se houver coleção mapeada, tenta trazer alguns exemplos já existentes
      if (colecao && usuarioLogado?.grupoId) {
        const snap = await getDocs(
          query(collection(db, colecao), where("grupoId", "==", usuarioLogado.grupoId))
        );

        const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

        docs.forEach((docItem) => {
          const linha = headerCols.map((col) => {
            const val = docItem[col];
            if (val === undefined || val === null) return "";
            if (val instanceof Date) return val.toISOString();
            return String(val);
          });
          linhas.push(linha.join(SEPARADOR));
        });
      }
    } catch (e) {
      console.error("Falha ao carregar dados de exemplo para o modelo CSV:", e);
    }

    const conteudo = linhas.join("\r\n");

    try {
      const blob = new Blob([conteudo], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `modelo_${tipoSelecionado}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Falha ao baixar modelo CSV:", e);
    }
  };

  const limparEstado = () => {
    setArquivoNome("");
    setPreviewHeader([]);
    setPreviewRows([]);
    setParsedRows([]);
    setMensagem("");
    setErro("");
    setResumoImportacao(null);
  };

  const selecionarTipo = (valor) => {
    setTipoSelecionado(valor);
    setModoAtivo(null);
    limparEstado();
  };

  const handleExportar = async () => {
    if (!tipoSelecionado || !tipoConfig) return;
    setErro("");
    setMensagem("");
    setResumoImportacao(null);

    if (!usuarioLogado?.grupoId) {
      setErro("Usuário não possui grupo definido.");
      return;
    }

    setCarregando(true);

    try {
      const colecaoMap = {
        empresas: "empresas",
        setores: "setores",
        maquinas: "maquinas",
usuarios: "usuarios",
        defeitos: "defeitos",
        fornecedores: "fornecedores",
        pecas: "pecas",
        ordensServico: "ordensServico",
        atendimentos: "atendimentos",
      };

      const colecao = colecaoMap[tipoSelecionado];
      if (!colecao) {
        setErro("Tipo de dado não suportado.");
        return;
      }

      const q = query(
        collection(db, colecao),
        where("grupoId", "==", usuarioLogado.grupoId)
      );
      const snap = await getDocs(q);
      const dados = snap.docs.map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }));

      if (dados.length === 0) {
        setErro(`Nenhum registro de ${tipoConfig.label} encontrado.`);
        return;
      }

      const csv = criaCsv(dados, tipoConfig.colunas);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const hoje = new Date().toISOString().slice(0, 10);
      link.download = `export_${tipoSelecionado}_${hoje}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setMensagem(
        `Arquivo CSV de ${tipoConfig.label} exportado com sucesso! (${dados.length} registros)`
      );
    } catch (e) {
      console.error("Erro ao exportar:", e);
      setErro("Erro ao exportar dados. Tente novamente.");
    } finally {
      setCarregando(false);
    }
  };

  const handleArquivoChange = (event) => {
    setErro("");
    setMensagem("");
    setResumoImportacao(null);

    const file = event.target.files?.[0];
    if (!file) {
      limparEstado();
      return;
    }

    setArquivoNome(file.name);

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const texto = e.target?.result ?? "";
        const { header, rows } = parseCsv(String(texto));

        if (!header || header.length === 0) {
          setErro("Cabeçalho do CSV não identificado.");
          return;
        }

        setPreviewHeader(header);
        setPreviewRows(rows.slice(0, 10));
        setParsedRows(rows);
        setMensagem(`Arquivo lido: ${rows.length} linha(s) pronta(s) para importação.`);
      } catch (err) {
        console.error("Erro ao ler arquivo:", err);
        setErro("Erro ao ler arquivo. Verifique o formato CSV.");
      }
    };
    reader.onerror = () => setErro("Erro ao carregar arquivo.");
    reader.readAsText(file, "utf-8");
  };

  const handleImportar = async () => {
    if (!tipoSelecionado || !tipoConfig) return;
    if (!usuarioLogado?.grupoId) {
      setErro("Usuário não possui grupo definido.");
      return;
    }
    if (!parsedRows || parsedRows.length === 0) {
      setErro("Nenhuma linha carregada para importação.");
      return;
    }

    setCarregando(true);
    setErro("");
    setMensagem("");

    try {
      const colecaoMap = {
        empresas: "empresas",
        setores: "setores",
        maquinas: "maquinas",
usuarios: "usuarios",
        defeitos: "defeitos",
        fornecedores: "fornecedores",
        pecas: "pecas",
        ordensServico: "ordensServico",
        atendimentos: "atendimentos",
      };

      const colecao = colecaoMap[tipoSelecionado];

      if (!colecao) {
        setErro("Tipo de dado não suportado para importação.");
        setCarregando(false);
        return;
      }

      // Registros já existentes (para atualização por código)
      const qBase = query(
        collection(db, colecao),
        where("grupoId", "==", usuarioLogado.grupoId)
      );
      const snapBase = await getDocs(qBase);

      const mapaPorCodigo = new Map();
      snapBase.docs.forEach((docSnap) => {
        const dados = docSnap.data();
        if (dados.codigo) {
          mapaPorCodigo.set(String(dados.codigo).trim(), {
            id: docSnap.id,
            dados,
          });
        }
      });

      // Coleções auxiliares para relacionamentos
      let empresas = [];
      let setores = [];
      let maquinas = [];
const precisaEmpresas = [
        "setores",
        "maquinas",
"defeitos",
        "ordensServico",
      ].includes(tipoSelecionado);
      const precisaSetores = ["maquinas", "defeitos", "ordensServico"].includes(
        tipoSelecionado
      );
      const precisaMaquinas = ["defeitos", "ordensServico"].includes(
        tipoSelecionado
      );
if (precisaEmpresas) {
        const snapEmp = await getDocs(
          query(collection(db, "empresas"), where("grupoId", "==", usuarioLogado.grupoId))
        );
        empresas = snapEmp.docs.map((d) => ({ id: d.id, ...d.data() }));
      }

      if (precisaSetores) {
        const snapSet = await getDocs(
          query(collection(db, "setores"), where("grupoId", "==", usuarioLogado.grupoId))
        );
        setores = snapSet.docs.map((d) => ({ id: d.id, ...d.data() }));
      }

      if (precisaMaquinas) {
        const snapMaq = await getDocs(
          query(collection(db, "maquinas"), where("grupoId", "==", usuarioLogado.grupoId))
        );
        maquinas = snapMaq.docs.map((d) => ({ id: d.id, ...d.data() }));
      }
const headerNormalizado = {};
      previewHeader.forEach((h) => {
        headerNormalizado[normalizaColuna(h)] = h;
      });

      const buscaValor = (linha, colEsperada) => {
        const colNorm = normalizaColuna(colEsperada);
        const colOriginal = headerNormalizado[colNorm];
        if (colOriginal && linha[colOriginal] !== undefined) {
          return String(linha[colOriginal] ?? "").trim();
        }
        if (linha[colEsperada] !== undefined) {
          return String(linha[colEsperada] ?? "").trim();
        }
        return "";
      };

      let linhasCriadas = 0;
      let linhasAtualizadas = 0;
      let linhasComErro = 0;

      console.log("[IMPORT DEBUG] Iniciando importação de", tipoSelecionado, "- total linhas:", parsedRows.length);
      
      for (const linha of parsedRows) {
        const codigoBruto = buscaValor(linha, "codigo");
        console.log("[IMPORT DEBUG] Processando linha:", codigoBruto);

        const novoRegistro = {};
        for (const col of tipoConfig.colunas) {
          const valorLinha = buscaValor(linha, col);
          if (!valorLinha && col !== "codigo") continue;

          // campos booleanos típicos
          if (
            col.includes("Chave") ||
            col === "ativo" ||
            col === "maquinaParou" ||
            col === "maquinaContinuaParada"
          ) {
            const bool = interpretaBoolean(valorLinha);
            if (bool !== null) novoRegistro[col] = bool;
          } else {
            novoRegistro[col] = valorLinha;
          }
        }

        // Regras específicas por tipo para resolver relacionamentos
        if (tipoSelecionado === "setores") {
          const empresaCodigo = buscaValor(linha, "empresaCodigo");
          let empresaId = null;
          let empresaNome = null;

          if (empresaCodigo && empresas.length > 0) {
            const codigoProc = empresaCodigo.trim().toLowerCase();
            const emp = empresas.find(
              (e) => (e.codigo || "").trim().toLowerCase() === codigoProc
            );
            if (emp) {
              empresaId = emp.id;
              empresaNome = emp.nome || null;
            }

          novoRegistro.empresaCodigo = empresaCodigo || null;
          novoRegistro.empresaId = empresaId || null;
          novoRegistro.empresaNome = empresaNome;
        }

        if (tipoSelecionado === "maquinas") {
          const empresaCodigo = buscaValor(linha, "empresaCodigo");
          const setorCodigo = buscaValor(linha, "setorCodigo");

          let empresaId = null;
          let setorId = null;
          let empresaNome = null;
          let setorNome = null;

          if (empresaCodigo && empresas.length > 0) {
            const codigoProc = empresaCodigo.trim().toLowerCase();
            const emp = empresas.find(
              (e) => (e.codigo || "").trim().toLowerCase() === codigoProc
            );
            if (emp) {
              empresaId = emp.id;
              empresaNome = emp.nome || null;
            }
          }

          if (empresaId && setorCodigo && setores.length > 0) {
            const setorCodigoProc = setorCodigo.trim().toLowerCase();
            const set = setores.find(
              (s) =>
                s.empresaId === empresaId &&
                (s.codigo || "").trim().toLowerCase() === setorCodigoProc
            );
            if (set) {
              setorId = set.id;
              setorNome = set.nome || null;
            }

          novoRegistro.empresaCodigo = empresaCodigo || null;
          novoRegistro.empresaId = empresaId || null;
          novoRegistro.empresaNome = empresaNome;
          novoRegistro.setorCodigo = setorCodigo || null;
          novoRegistro.setorId = setorId || null;
          novoRegistro.setorNome = setorNome;
        }
        if (tipoSelecionado === "defeitos") {
          const empresaNome = buscaValor(linha, "empresaNome");
          const setorNome = buscaValor(linha, "setorNome");

          let empresaId = null;
          let setorId = null;

          if (empresaNome && empresas.length > 0) {
            const nomeProc = empresaNome.trim().toLowerCase();
            const emp = empresas.find(
              (e) => (e.nome || "").trim().toLowerCase() === nomeProc
            );
            if (emp) {
              empresaId = emp.id;
            }
          }

          if (empresaId && setorNome && setores.length > 0) {
            const nomeSetorProc = setorNome.trim().toLowerCase();
            const set = setores.find(
              (s) =>
                s.empresaId === empresaId &&
                (s.nome || "").trim().toLowerCase() === nomeSetorProc
            );
            if (set) {
              setorId = set.id;
            }
          }

          novoRegistro.empresaNome = empresaNome || null;
          novoRegistro.empresaId = empresaId || null;
          novoRegistro.setorNome = setorNome || null;
          novoRegistro.setorId = setorId || null;
        }

        if (tipoSelecionado === "ordensServico") {
          const empresaCodigo = buscaValor(linha, "empresaCodigo");
          const setorCodigo = buscaValor(linha, "setorCodigo");
          const maquinaCodigo = buscaValor(linha, "maquinaCodigo");
let empresaId = null;
          let setorId = null;
          let maquinaId = null;
let empresaNome = null;
          let setorNome = null;
          let maquinaNome = null;
// Empresa pelo código (EM0001)
          if (empresaCodigo && empresas.length > 0) {
            const codEmp = empresaCodigo.trim().toLowerCase();
            const emp = empresas.find(
              (e) => (e.codigo || "").trim().toLowerCase() === codEmp
            );
            if (emp) {
              empresaId = emp.id;
              empresaNome = emp.nome || null;
            }
          }

          // Setor pelo código (ST001) dentro da mesma empresa
          if (empresaId && setorCodigo && setores.length > 0) {
            const codSet = setorCodigo.trim().toLowerCase();
            const set = setores.find(
              (s) =>
                s.empresaId === empresaId &&
                (s.codigo || "").trim().toLowerCase() === codSet
            );
            if (set) {
              setorId = set.id;
              setorNome = set.nome || null;
            }
          }

          // Máquina pelo código (MQ0001) dentro da mesma empresa
          let maquinaChave = false;
          if (empresaId && maquinaCodigo && maquinas.length > 0) {
            const codMaq = maquinaCodigo.trim().toLowerCase();
            const maq = maquinas.find(
              (m) =>
                m.empresaId === empresaId &&
                (m.codigo || "").trim().toLowerCase() === codMaq
            );
            if (maq) {
              maquinaId = maq.id;
              maquinaNome = maq.nome || null;
              maquinaChave = !!maq.maquinaChave;
              // se não veio setor, tenta pegar da máquina
              if (!setorId && maq.setorId) {
                setorId = maq.setorId;
                setorNome = maq.setorNome || setorNome;
              }
            }
          }

          novoRegistro.empresaCodigo = empresaCodigo || null;
          novoRegistro.setorCodigo = setorCodigo || null;
          novoRegistro.maquinaCodigo = maquinaCodigo || null;
novoRegistro.empresaId = empresaId;
          novoRegistro.empresaNome = empresaNome;
          novoRegistro.setorId = setorId;
          novoRegistro.setorNome = setorNome;
          novoRegistro.maquinaId = maquinaId;
          novoRegistro.maquinaNome = maquinaNome;
          novoRegistro.maquinaChave = maquinaChave;
// Mapear status texto para statusId/statusNome/statusCor
          const statusTexto = buscaValor(linha, "status");
          if (statusTexto) {
            const statusLower = statusTexto.trim().toLowerCase();
            const STATUS_MAP = {
              "aberta": { id: "fab_aberta", nome: "Aberta", cor: "#2563eb" },
              "aberta 24h": { id: "fab_aberta_24h", nome: "Aberta 24H", cor: "#7c3aed" },
              "em atendimento": { id: "fab_em_atendimento", nome: "Em Atendimento", cor: "#3b82f6" },
              "aguardando peça": { id: "fab_aguardando_peca", nome: "Aguardando Peça", cor: "#f59e0b" },
              "aguardando peca": { id: "fab_aguardando_peca", nome: "Aguardando Peça", cor: "#f59e0b" },
              "finalizada": { id: "fab_finalizada", nome: "Finalizada", cor: "#22c55e" },
              "cancelada": { id: "fab_cancelada", nome: "Cancelada", cor: "#ef4444" },
            };
            const statusInfo = STATUS_MAP[statusLower] || STATUS_MAP["aberta"];
            novoRegistro.statusId = statusInfo.id;
            novoRegistro.statusNome = statusInfo.nome;
            novoRegistro.statusCor = statusInfo.cor;
            delete novoRegistro.status; // Remove campo texto, usa statusId
          } else if (!novoRegistro.statusId) {
            // Se não veio status, usar padrão "Aberta"
            novoRegistro.statusId = "fab_aberta";
            novoRegistro.statusNome = "Aberta";
            novoRegistro.statusCor = "#2563eb";
          }

          // Converter maquinaParou para boolean se vier como texto
          const maqParouVal = buscaValor(linha, "maquinaParou");
          if (maqParouVal !== undefined && maqParouVal !== null) {
            const parouLower = String(maqParouVal).trim().toLowerCase();
            novoRegistro.maquinaParou = ["sim", "s", "true", "1", "yes"].includes(parouLower);
          }

          // Setar titulo se não vier (usar defeitoApresentado)
          if (!novoRegistro.titulo && novoRegistro.defeitoApresentado) {
            novoRegistro.titulo = novoRegistro.defeitoApresentado;
          }
        }

        // Validações obrigatórias por tipo
        if (tipoSelecionado === "setores") {
          if (!novoRegistro.empresaId) {
            console.warn(
              "Linha ignorada: empresaCodigo não encontrado ao importar setor."
            );
            linhasComErro += 1;
            continue;
          }
        }

        if (tipoSelecionado === "maquinas") {
          if (!novoRegistro.empresaId || !novoRegistro.setorId) {
            console.warn(
              "Linha ignorada: empresaCodigo ou setorCodigo não encontrado ao importar máquina."
            );
            linhasComErro += 1;
            continue;
          }
        }
}

        if (tipoSelecionado === "ordensServico") {
          if (!novoRegistro.empresaId || !novoRegistro.maquinaId) {
            console.warn(
              "Importando OS sem empresaId ou maquinaId resolvidos. Verifique os códigos de empresa/máquina."
            );
            // Mantemos a linha mesmo assim, usando os códigos da planilha.
          }
        }

        // Ignora linhas totalmente vazias (sem nada além de código)
        const camposPreenchidos = Object.keys(novoRegistro).filter((k) => k !== "codigo");
        console.log("[IMPORT DEBUG] Campos preenchidos:", camposPreenchidos.length, camposPreenchidos);
        if (camposPreenchidos.length === 0) {
          console.log("[IMPORT DEBUG] Linha ignorada - sem campos além de codigo");
          linhasComErro += 1;
          continue;
        }

        const atual = codigoBruto ? mapaPorCodigo.get(codigoBruto) : null;
        console.log("[IMPORT DEBUG] Registro existente?", !!atual, "- Vai criar novo?", !atual);

        if (atual) {
          const ref = doc(db, colecao, atual.id);
          const patch = { ...novoRegistro };
          delete patch.codigo;

          if (Object.keys(patch).length > 0) {
            await updateDoc(ref, patch);
            linhasAtualizadas += 1;
          }
        } else {
          // Para novos registros de tipos com código sequencial automático,
          // ignoramos qualquer "codigo" vindo do arquivo para evitar códigos fora do padrão.
          const tiposComCodigoAuto = [
            "empresas",
            "setores",
            "maquinas",
"usuarios",
            "fornecedores",
            "pecas",
          ];
          if (tiposComCodigoAuto.includes(tipoSelecionado)) {
            delete novoRegistro.codigo;
          }

          novoRegistro.grupoId = usuarioLogado.grupoId;
          novoRegistro.grupoNome = usuarioLogado.grupoNome || usuarioLogado.grupoId;
          novoRegistro.criadoEm = new Date();
          console.log("[DEBUG IMPORT] grupoId usado:", usuarioLogado.grupoId, "grupoNome:", usuarioLogado.grupoNome);

          // Geração de código para novos registros sem código definido (somente tipos com código automático)
          if (!novoRegistro.codigo && tiposComCodigoAuto.includes(tipoSelecionado)) {
            const config = CODIGO_CONFIG[tipoSelecionado];

            if (config && usuarioLogado?.grupoId) {
              try {
                const { sequencial, codigoGerado } = await gerarCodigoSequencialPorTipo(
                  tipoSelecionado,
                  usuarioLogado.grupoId
                );
                if (sequencial != null && codigoGerado) {
                  novoRegistro.codigoSequencial = sequencial;
                  novoRegistro.codigo = codigoGerado;
                }
              } catch (e) {
                console.error(
                  "Falha ao gerar código sequencial, usando fallback IMP-*",
                  e
                );
              }
            }

            if (!novoRegistro.codigo) {
              novoRegistro.codigo = `IMP-${Date.now()}-${Math.random()
                .toString(36)
                .substr(2, 5)}`;
            }
          }

          console.log("[IMPORT DEBUG] Salvando novo registro:", JSON.stringify(novoRegistro, null, 2));
          try {
            const docRef = await addDoc(collection(db, colecao), novoRegistro);
            console.log("[IMPORT DEBUG] Registro criado com ID:", docRef.id);
            linhasCriadas += 1;
          } catch (saveError) {
            console.error("[IMPORT DEBUG] ERRO ao salvar:", saveError);
            linhasComErro += 1;
          }
        }
      }
      }

      setResumoImportacao({
        totalLinhas: parsedRows.length,
        linhasCriadas,
        linhasAtualizadas,
        linhasComErro,
      });

      setMensagem(`Importação de ${tipoConfig.label} concluída!`);
    } catch (e) {
      console.error("Erro ao importar:", e);
      setErro("Erro ao importar dados. Verifique o arquivo e tente novamente.");
    } finally {
      setCarregando(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid var(--cor-borda-input, #334155)",
    background: "var(--cor-input-bg, transparent)",
    color: "var(--cor-input-texto, inherit)",
    fontSize: 14,
  };

  return (
    <LayoutDesktop
      tema={tema}
      titulo="Importar / Exportar"
      subtitulo=""
    >
      <div style={{ display: "flex", gap: 0, marginBottom: 24 }}>
        <button
          type="button"
          onClick={() => setAbaAtiva("dados")}
          style={{
            padding: "12px 24px",
            border: "none",
            borderBottom: abaAtiva === "dados" ? "3px solid var(--cor-laranja, #f97316)" : "3px solid transparent",
            background: abaAtiva === "dados" ? "var(--cor-card, rgba(255,255,255,0.05))" : "transparent",
            color: abaAtiva === "dados" ? "var(--cor-texto)" : "var(--cor-texto-secundario, #888)",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: abaAtiva === "dados" ? 600 : 400,
            transition: "all 0.2s ease",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <path d="M3 9h18M9 21V9" />
          </svg>
          Importar / Exportar
        </button>
        <button
          type="button"
          onClick={() => setAbaAtiva("assistente")}
          style={{
            padding: "12px 24px",
            border: "none",
            borderBottom: abaAtiva === "assistente" ? "3px solid var(--cor-laranja, #f97316)" : "3px solid transparent",
            background: abaAtiva === "assistente" ? "var(--cor-card, rgba(255,255,255,0.05))" : "transparent",
            color: abaAtiva === "assistente" ? "var(--cor-texto)" : "var(--cor-texto-secundario, #888)",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: abaAtiva === "assistente" ? 600 : 400,
            transition: "all 0.2s ease",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M12 2a10 10 0 0 1 10 10c0 5.52-4.48 10-10 10a10 10 0 0 1-10-10c0-5.52 4.48-10 10-10z" />
            <path d="M12 16v-4M12 8h.01" />
          </svg>
          Assistente GPT
        </button>
      </div>

      {abaAtiva === "assistente" && (
        <section className="pc-card" style={{ padding: 24 }}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 16, marginBottom: 20 }}>
            <div style={{ 
              width: 56, 
              height: 56, 
              borderRadius: 12, 
              background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <path d="M12 17h.01" />
              </svg>
            </div>
            <div>
              <h3 style={{ margin: 0, marginBottom: 4 }}>Assistente GPT para Importação</h3>
              <p style={{ margin: 0, fontSize: 14, opacity: 0.8, lineHeight: 1.5 }}>
                Use este script no ChatGPT ou outro assistente de IA para converter suas planilhas 
                existentes em CSVs prontos para importação no Sistema Mamute.
              </p>
            </div>
          </div>

          <div style={{ 
            background: "var(--cor-card-inner, rgba(0,0,0,0.2))", 
            borderRadius: 12, 
            padding: 20,
            marginBottom: 20,
          }}>
            <h4 style={{ margin: 0, marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              Como usar:
            </h4>
            <ol style={{ margin: 0, paddingLeft: 20, fontSize: 14, lineHeight: 1.8 }}>
              <li>Clique em <strong>"Carregar Dados do Sistema"</strong> para incluir seus cadastros no script</li>
              <li>Clique em <strong>"Copiar Script"</strong></li>
              <li>Abra o <strong>ChatGPT</strong> (ou outro assistente de IA)</li>
              <li>Cole o script na conversa</li>
              <li>Envie suas planilhas (Excel, Google Sheets, etc.) junto com uma descrição</li>
              <li>O GPT vai gerar os CSVs usando os códigos corretos dos seus cadastros</li>
              <li>Copie cada CSV e importe na aba <strong>"Importar / Exportar"</strong></li>
            </ol>
          </div>

          <div style={{ 
            padding: 16, 
            borderRadius: 12, 
            background: dadosCadastrados ? "rgba(16, 185, 129, 0.1)" : "rgba(249, 115, 22, 0.1)",
            border: dadosCadastrados ? "1px solid rgba(16, 185, 129, 0.3)" : "1px solid rgba(249, 115, 22, 0.3)",
            marginBottom: 20,
          }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={dadosCadastrados ? "#10b981" : "#f97316"} strokeWidth="2">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                  <line x1="12" y1="22.08" x2="12" y2="12" />
                </svg>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>
                    {dadosCadastrados ? "Dados carregados!" : "Dados do sistema não carregados"}
                  </div>
                  {dadosCadastrados ? (
                    <div style={{ fontSize: 12, opacity: 0.8 }}>
                      {dadosCadastrados.empresas.length} empresas, {dadosCadastrados.setores.length} setores, {dadosCadastrados.maquinas.length} máquinas {dadosCadastrados.ordensServico.length} OS
                    </div>
                  ) : (
                    <div style={{ fontSize: 12, opacity: 0.8 }}>
                      Carregue os dados para que o GPT saiba quais códigos usar nos relacionamentos
                    </div>
                  )}
                </div>
              </div>
              <button
                type="button"
                onClick={carregarDadosCadastrados}
                disabled={carregandoDados}
                style={{
                  padding: "10px 20px",
                  borderRadius: 8,
                  border: "none",
                  background: dadosCadastrados ? "#10b981" : "var(--cor-laranja, #f97316)",
                  color: "white",
                  cursor: carregandoDados ? "wait" : "pointer",
                  fontSize: 13,
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  opacity: carregandoDados ? 0.7 : 1,
                }}
              >
                {carregandoDados ? (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ animation: "spin 1s linear infinite" }}>
                      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                    </svg>
                    Carregando...
                  </>
                ) : dadosCadastrados ? (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="23 4 23 10 17 10" />
                      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
                    </svg>
                    Atualizar Dados
                  </>
                ) : (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                    Carregar Dados do Sistema
                  </>
                )}
              </button>
            </div>
          </div>

          <div style={{ 
            background: "var(--cor-fundo, #0d1b2a)", 
            borderRadius: 12, 
            border: "1px solid var(--cor-borda-input, #334155)",
            overflow: "hidden",
          }}>
            <div style={{ 
              padding: "12px 16px", 
              background: "var(--cor-card-inner, rgba(255,255,255,0.05))",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid var(--cor-borda-input, #334155)",
            }}>
              <span style={{ fontSize: 13, fontWeight: 500, opacity: 0.8 }}>
                script-importacao-mamute.txt {dadosCadastrados && <span style={{ color: "#10b981" }}>(com dados)</span>}
              </span>
              <button
                type="button"
                onClick={handleCopiarScript}
                style={{
                  padding: "8px 16px",
                  borderRadius: 8,
                  border: "none",
                  background: copiado ? "#10b981" : "var(--cor-laranja, #f97316)",
                  color: "white",
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  transition: "all 0.2s ease",
                }}
              >
                {copiado ? (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    Copiado!
                  </>
                ) : (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                    Copiar Script
                  </>
                )}
              </button>
            </div>
            <pre style={{ 
              margin: 0, 
              padding: 16, 
              fontSize: 12, 
              lineHeight: 1.6,
              maxHeight: 400,
              overflow: "auto",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              color: "var(--cor-texto)",
              fontFamily: "monospace",
            }}>
              {gerarScriptComDados()}
            </pre>
          </div>

          <div style={{ 
            marginTop: 20, 
            padding: 16, 
            borderRadius: 12, 
            background: "rgba(59, 130, 246, 0.1)",
            border: "1px solid rgba(59, 130, 246, 0.3)",
          }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" style={{ flexShrink: 0, marginTop: 2 }}>
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
              <div style={{ fontSize: 13, lineHeight: 1.6 }}>
                <strong>Dica:</strong> Ao carregar os dados, o script incluirá todos os códigos já cadastrados (empresas, setores, máquinas, etc). 
                Assim o GPT saberá exatamente quais códigos usar nos relacionamentos do CSV.
              </div>
            </div>
          </div>
        </section>
      )}

      {abaAtiva === "dados" && (
      <section className="pc-card" style={{ padding: 24 }}>
        <h3 style={{ marginBottom: 8 }}>Selecione o tipo de dados</h3>
        <p style={{ fontSize: 14, opacity: 0.8, marginBottom: 20 }}>
          Escolha qual tabela deseja exportar ou importar. A importação cria registros novos ou atualiza existentes (pelo código).
          <br />
          <strong>Sugestão de sequência para novos clientes:</strong> Empresas → Setores → Máquinas → Submáquinas → Defeitos.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
            gap: 12,
            marginBottom: 24,
          }}
        >
          {TIPOS_DADOS.map((tipo) => (
            <button
              key={tipo.value}
              type="button"
              onClick={() => selecionarTipo(tipo.value)}
              style={{
                padding: 16,
                borderRadius: 12,
                border:
                  tipoSelecionado === tipo.value
                    ? "2px solid var(--cor-acento, #2563eb)"
                    : "1px solid var(--cor-borda-input, #334155)",
                background:
                  tipoSelecionado === tipo.value
                    ? "var(--cor-acento-soft, rgba(37, 99, 235, 0.15))"
                    : "var(--cor-card, rgba(255,255,255,0.03))",
                color: "var(--cor-texto)",
                cursor: "pointer",
                textAlign: "left",
                transition: "all 0.2s ease",
              }}
            >
              <div
                style={{
                  marginBottom: 8,
                  color: "var(--cor-laranja, #f97316)",
                }}
              >
                {tipo.icon}
              </div>
              <div
                style={{
                  fontWeight: 600,
                  fontSize: 15,
                  marginBottom: 4,
                  color: "var(--cor-texto)",
                }}
              >
                {tipo.label}
              </div>
              <div
                style={{
                  fontSize: 12,
                  opacity: 0.7,
                  lineHeight: 1.4,
                  color: "var(--cor-texto)",
                }}
              >
                {tipo.descricao}
              </div>
            </button>
          ))}
        </div>

        {tipoSelecionado && tipoConfig && (
          <>
            <div
              style={{
                padding: 16,
                borderRadius: 10,
                background: "var(--cor-card-inner, rgba(255,255,255,0.03))",
                marginBottom: 20,
              }}
            >
              <div style={{ fontWeight: 600, marginBottom: 8 }}>
                {tipoConfig.icon} {tipoConfig.label} selecionado
              </div>
              <div style={{ fontSize: 13, opacity: 0.8 }}>
                <strong>Colunas do CSV:</strong> {tipoConfig.colunas.join(", ")}
              </div>
              <div style={{ fontSize: 12, opacity: 0.7, marginTop: 8 }}>
                {obterAjudaImportacao()}
              </div>
            </div>

            <div
              style={{
                padding: 16,
                borderRadius: 10,
                background: "var(--cor-card-inner, rgba(255,255,255,0.03))",
                marginBottom: 20,
              }}
            >
              <div style={{ fontWeight: 600, marginBottom: 8 }}>
                💡 Usar ChatGPT para preparar o arquivo de importação
              </div>
              <p style={{ fontSize: 13, opacity: 0.8, marginBottom: 8 }}>
                Copie o texto abaixo, cole no ChatGPT junto com a sua planilha de{" "}
                <strong>{tipoConfig.label}</strong> e peça para ele devolver o CSV já
                no padrão do Mamute. Depois é só baixar o CSV e usar a opção{" "}
                <strong>Importar</strong> aqui na tela.
              </p>
              
              <div style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: 12, 
                marginBottom: 12,
                padding: "10px 14px",
                background: dadosCadastrados ? "rgba(16, 185, 129, 0.1)" : "rgba(249, 115, 22, 0.1)",
                borderRadius: 8,
                border: `1px solid ${dadosCadastrados ? "rgba(16, 185, 129, 0.3)" : "rgba(249, 115, 22, 0.3)"}`,
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>
                    {dadosCadastrados ? "✓ Dados carregados!" : "⚠ Dados do sistema não carregados"}
                  </div>
                  <div style={{ fontSize: 11, opacity: 0.8 }}>
                    {dadosCadastrados 
                      ? `${dadosCadastrados.empresas.length} empresas, ${dadosCadastrados.maquinas.length} máquinas, ${dadosCadastrados.ordensServico.length} OS`
                      : "Carregue os dados para incluir os códigos existentes no script"}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={carregarDadosCadastrados}
                  disabled={carregandoDados}
                  style={{
                    padding: "8px 14px",
                    borderRadius: 6,
                    border: "none",
                    background: dadosCadastrados ? "#10b981" : "#f97316",
                    color: "white",
                    cursor: carregandoDados ? "wait" : "pointer",
                    fontSize: 12,
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    opacity: carregandoDados ? 0.7 : 1,
                    whiteSpace: "nowrap",
                  }}
                >
                  {carregandoDados ? "Carregando..." : dadosCadastrados ? "Atualizar" : "Carregar Dados"}
                </button>
              </div>

              <textarea
                readOnly
                value={gerarScriptChatGPT()}
                style={{
                  width: "100%",
                  minHeight: 180,
                  fontSize: 12,
                  fontFamily: "monospace",
                  padding: 12,
                  borderRadius: 8,
                  border: "1px solid rgba(148,163,184,0.4)",
                  background: "rgba(15,23,42,0.6)",
                  color: "var(--cor-texto)",
                  resize: "vertical",
                  whiteSpace: "pre",
                }}
              />
              <button
                type="button"
                onClick={async () => {
                  const texto = gerarScriptChatGPT();
                  if (!texto) return;
                  try {
                    await navigator.clipboard.writeText(texto);
                    setMensagem("Script para ChatGPT copiado para a área de transferência.");
                    setErro("");
                  } catch (e) {
                    setMensagem("");
                    setErro("Não foi possível copiar automaticamente. Copie o texto manualmente.");
                  }
                }}
                style={{
                  marginTop: 8,
                  padding: "6px 12px",
                  borderRadius: 6,
                  border: "none",
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: 500,
                  background: "var(--cor-primaria, #22c55e)",
                  color: "#0b1120",
                }}
              >
                Copiar script para ChatGPT
              </button>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 16,
                marginBottom: 24,
              }}
            >
              <button
                type="button"
                onClick={() => {
                  setModoAtivo("exportar");
                  limparEstado();
                }}
                disabled={carregando}
                style={{
                  padding: 20,
                  borderRadius: 12,
                  border:
                    modoAtivo === "exportar"
                      ? "2px solid #16a34a"
                      : "1px solid var(--cor-borda-input, #334155)",
                  background:
                    modoAtivo === "exportar"
                      ? "rgba(22, 163, 74, 0.15)"
                      : "var(--cor-card, rgba(255,255,255,0.03))",
                  color: "var(--cor-texto)",
                  cursor: "pointer",
                  textAlign: "center",
                }}
              >
                <div style={{ marginBottom: 8, color: "#16a34a" }}>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                </div>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: 16,
                    color: "var(--cor-texto)",
                  }}
                >
                  Exportar
                </div>
                <div
                  style={{
                    fontSize: 12,
                    opacity: 0.7,
                    marginTop: 4,
                    color: "var(--cor-texto)",
                  }}
                >
                  Baixar dados em CSV
                </div>
              </button>

              <button
                type="button"
                onClick={() => {
                  setModoAtivo("importar");
                  limparEstado();
                }}
                disabled={carregando}
                style={{
                  padding: 20,
                  borderRadius: 12,
                  border:
                    modoAtivo === "importar"
                      ? "2px solid #2563eb"
                      : "1px solid var(--cor-borda-input, #334155)",
                  background:
                    modoAtivo === "importar"
                      ? "rgba(37, 99, 235, 0.15)"
                      : "var(--cor-card, rgba(255,255,255,0.03))",
                  color: "var(--cor-texto)",
                  cursor: "pointer",
                  textAlign: "center",
                }}
              >
                <div style={{ marginBottom: 8, color: "#2563eb" }}>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </div>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: 16,
                    color: "var(--cor-texto)",
                  }}
                >
                  Importar
                </div>
                <div
                  style={{
                    fontSize: 12,
                    opacity: 0.7,
                    marginTop: 4,
                    color: "var(--cor-texto)",
                  }}
                >
                  Criar ou atualizar dados via CSV
                </div>
              </button>
            </div>

            {modoAtivo === "exportar" && (
              <div
                style={{
                  padding: 20,
                  borderRadius: 12,
                  background: "rgba(22, 163, 74, 0.08)",
                  border: "1px solid rgba(22, 163, 74, 0.3)",
                }}
              >
                <h4
                  style={{
                    marginBottom: 12,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#16a34a"
                    strokeWidth="2"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                  Exportar {tipoConfig.label}
                </h4>
                <p
                  style={{
                    fontSize: 13,
                    opacity: 0.8,
                    marginBottom: 16,
                  }}
                >
                  Será gerado um arquivo CSV com todos os registros de{" "}
                  {tipoConfig.label} do seu grupo. Use ponto-e-vírgula (;) como
                  separador ao editar no Excel.
                </p>
                <button
                  type="button"
                  className="pc-btn-primario"
                  onClick={handleExportar}
                  disabled={carregando}
                  style={{ minWidth: 180 }}
                >
                  {carregando
                    ? "Exportando..."
                    : `Exportar ${tipoConfig.label}`}
                </button>
              </div>
            )}

            {modoAtivo === "importar" && (
              <div
                style={{
                  padding: 20,
                  borderRadius: 12,
                  background: "rgba(37, 99, 235, 0.08)",
                  border: "1px solid rgba(37, 99, 235, 0.3)",
                }}
              >
                <h4
                  style={{
                    marginBottom: 12,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#2563eb"
                    strokeWidth="2"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                  Importar {tipoConfig.label}
                </h4>
                <p
                  style={{
                    fontSize: 13,
                    opacity: 0.8,
                    marginBottom: 16,
                  }}
                >
                  A importação <strong>cria novos registros</strong> ou{" "}
                  <strong>atualiza existentes</strong>, identificando-os pela
                  coluna "codigo". Registros com código existente serão
                  atualizados; com código novo ou vazio serão criados (para os
                  tipos que possuem código automático).
                </p>

                <div style={{ marginBottom: 16 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: 6,
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    Selecione o arquivo CSV:
                  </label>
                  <input
                    type="file"
                    accept=".csv,.txt"
                    onChange={handleArquivoChange}
                    style={inputStyle}
                  />
                  {arquivoNome && (
                    <div
                      style={{
                        marginTop: 8,
                        fontSize: 13,
                        opacity: 0.8,
                      }}
                    >
                      Arquivo: <strong>{arquivoNome}</strong>
                    </div>
                  )}

                  <div
                    style={{
                      marginTop: 12,
                      display: "flex",
                      gap: 8,
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <button
                      type="button"
                      className="pc-btn-secundario"
                      onClick={handleBaixarModelo}
                      disabled={carregando || !tipoConfig}
                      style={{ minWidth: 160 }}
                    >
                      Baixar modelo CSV
                    </button>
                    <span
                      style={{
                        fontSize: 12,
                        opacity: 0.75,
                      }}
                    >
                      Baixe o modelo, preencha os dados e depois selecione o
                      arquivo para importar.
                    </span>
                  </div>
                </div>

                {previewRows.length > 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <h5 style={{ marginBottom: 8 }}>
                      Prévia dos dados (primeiras 10 linhas):
                    </h5>
                    <div
                      style={{
                        overflowX: "auto",
                        maxHeight: 200,
                      }}
                    >
                      <table className="pc-table" style={{ fontSize: 12 }}>
                        <thead>
                          <tr>
                            {previewHeader.map((col) => (
                              <th key={col}>{col}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {previewRows.map((row, idx) => (
                            <tr key={idx}>
                              {previewHeader.map((col) => (
                                <td key={col}>{row[col] || "-"}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {parsedRows.length > 0 && (
                  <button
                    type="button"
                    className="pc-btn-primario"
                    onClick={handleImportar}
                    disabled={carregando}
                    style={{ minWidth: 180 }}
                  >
                    {carregando
                      ? "Importando..."
                      : `Importar ${parsedRows.length} registro(s)`}
                  </button>
                )}
              </div>
            )}
          </>
        )}

        {erro && (
          <div
            className="pc-alert pc-alert-erro"
            style={{ marginTop: 16 }}
          >
            {erro}
          </div>
        )}

        {mensagem && !erro && (
          <div
            className="pc-alert pc-alert-sucesso"
            style={{ marginTop: 16 }}
          >
            {mensagem}
          </div>
        )}

        {resumoImportacao && (
          <div
            style={{
              marginTop: 16,
              padding: 16,
              borderRadius: 10,
              background: "var(--cor-card-inner, rgba(255,255,255,0.03))",
              border: "1px solid var(--cor-borda-input, #334155)",
            }}
          >
            <h4 style={{ marginBottom: 12 }}>Resumo da Importação</h4>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: 12,
              }}
            >
              <div
                style={{
                  padding: 12,
                  borderRadius: 8,
                  background: "rgba(37, 99, 235, 0.1)",
                }}
              >
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 700,
                  }}
                >
                  {resumoImportacao.totalLinhas}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    opacity: 0.8,
                  }}
                >
                  Total de linhas
                </div>
              </div>
              <div
                style={{
                  padding: 12,
                  borderRadius: 8,
                  background: "rgba(34, 197, 94, 0.1)",
                }}
              >
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 700,
                    color: "#22c55e",
                  }}
                >
                  {resumoImportacao.linhasCriadas}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    opacity: 0.8,
                  }}
                >
                  Novos registros criados
                </div>
              </div>
              <div
                style={{
                  padding: 12,
                  borderRadius: 8,
                  background: "rgba(59, 130, 246, 0.1)",
                }}
              >
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 700,
                    color: "#3b82f6",
                  }}
                >
                  {resumoImportacao.linhasAtualizadas}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    opacity: 0.8,
                  }}
                >
                  Registros atualizados
                </div>
              </div>
              <div
                style={{
                  padding: 12,
                  borderRadius: 8,
                  background: "rgba(220, 38, 38, 0.1)",
                }}
              >
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 700,
                    color: "#dc2626",
                  }}
                >
                  {resumoImportacao.linhasComErro}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    opacity: 0.8,
                  }}
                >
                  Linhas com erro
                </div>
              </div>
            </div>
          </div>
        )}

        {!tipoSelecionado && (
          <div
            style={{
              padding: 40,
              textAlign: "center",
              opacity: 0.6,
            }}
          >
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" style={{ opacity: 0.5, marginBottom: 12 }}>
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <path d="M3 9h18M9 21V9" />
            </svg>
            <p>Selecione um tipo de dados acima para começar</p>
          </div>
        )}
      </section>
      )}
    </LayoutDesktop>
  );
}

export default ImportarExportarDados;
